import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAutopayPaymentsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#C5F1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 26H17.5",
			stroke: "#0080A3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.5,
			y: 12.5,
			width: 21,
			height: 15,
			rx: 2.5,
			fill: "white",
			stroke: "#30515B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9.5,
			y: 16.5,
			width: 21,
			height: 3,
			fill: "#4B7987",
			stroke: "#30515B"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 27,
			cy: 27,
			r: 4.5,
			fill: "white",
			stroke: "#30515B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 27L26.5 28.5L29 26",
			stroke: "#30515B",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledAutopayPaymentsIcon);
const Memo = memo(ForwardRef);
export default Memo;
